import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';

import { VideoRoutingModule } from './video-routing.module';
import { HomeVideoLibraryComponent } from './home-video-library.component';
import { VideoCardComponent } from './video-card/video-card.component';
import { VideoLibraryComponent } from './video-library/video-library.component';
import { SafeUrlPipe } from '../shared/pipe/safe-url.pipe';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [CommonModule, VideoRoutingModule, FormsModule, MatFormFieldModule, MatInputModule, MatIconModule,
        MatSelectModule,
        MatCardModule,
        MatTooltipModule,
        MatButtonModule,
        MatCardModule,
        RouterModule, HomeVideoLibraryComponent, VideoCardComponent, VideoLibraryComponent, SafeUrlPipe],
    exports: [HomeVideoLibraryComponent],
})
export class VideoModule {}
